// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__HxybZ","log":"ModalInventoryLogs_log__2MSr_","date":"ModalInventoryLogs_date__dOO_S","userName":"ModalInventoryLogs_userName__3wVDP"};